import axios from 'axios'
import {QUERIES} from '../../../../../../_metronic/helpers'
import {PaymentSetting} from './_models'

const API_URL = process.env.REACT_APP_API_V2_URL + '/' + QUERIES.PAYMENT_SETTINGS_LIST

const createPaymentSetting = (
  paymentSetting: PaymentSetting
): Promise<PaymentSetting | undefined> => axios.post(API_URL, paymentSetting)

const updatePaymentSetting = (
  paymentSetting: PaymentSetting
): Promise<PaymentSetting | undefined> =>
  axios.patch(`${API_URL}/${paymentSetting.id}`, paymentSetting)

export {createPaymentSetting, updatePaymentSetting}
